class Subnav {
	
	constructor(elements, scrollTopArray) {
		this.scrollTopArray = scrollTopArray;
		this.elements = elements;
		this.scrollY = 0;
		this.timer = null;

		this.onScroll = this.onScroll.bind(this);
		this.update = this.update.bind(this);

		window.addEventListener('scroll', this.onScroll, false);
	}

	onScroll() {
		this.scrollY = document.documentElement.scrollTop || document.body.scrollTop;

		clearTimeout(this.timer);
		this.timer = setTimeout(this.update, 100);
	}

	update() {

		this.elements.forEach((el, index) => {
			const next = index < this.scrollTopArray.length - 1 ? this.scrollTopArray[index + 1] : null;
			const current = this.scrollTopArray[index];

			if (this.scrollY > current && (!next || this.scrollY < next)) {
				this.elements[index].classList.add('activeLink');
			} else {
				this.elements[index].classList.remove('activeLink');
			}
		});
	}
}

export default Subnav;